module.exports = __webpack_public_path__ + "img/fxgl.b85d1aba.svg";